// extracted by mini-css-extract-plugin
export default {"ifc-viewer":"Zc7P1vzP1KP39kYwKArf","ifcViewer":"Zc7P1vzP1KP39kYwKArf"};